import React from 'react';
import { green } from '@/shared/styles/colors';
import { css } from '@emotion/native';
import { Text, TextProps } from 'react-native-paper';

const helvetica = { fontFamily: 'Helvetica' };
export const lora = css({ fontFamily: 'Lora' });

export const loraRegular = css({
  ...lora,
  fontWeight: 400,
});

export const loraBold = css({
  ...lora,
  fontWeight: 700,
});

export const fontScalingProps = {
  allowFontScaling: true,
  maxFontSizeMultiplier: 1.3,
  minimumFontScale: 0.8,
};

// Pre-define all style objects to prevent recreation on every render
const baseTextStyle = {
  ...helvetica,
  fontWeight: 'normal' as const,
};

const loraTextStyle = {
  ...loraRegular,
};

const h1Style = {
  ...loraRegular,
  fontSize: 40,
  letterSpacing: 0.8,
  lineHeight: 40.6,
  color: green,
};

const h2Style = {
  ...loraRegular,
  fontSize: 40,
  lineHeight: 40.6,
  letterSpacing: 0.68,
  fontWeight: 'normal' as const,
  color: green,
};

const h3Style = {
  ...loraRegular,
  fontSize: 30,
  lineHeight: 33,
  letterSpacing: -0.3,
  fontWeight: 'normal' as const,
  color: green,
};

const h4Style = {
  ...loraRegular,
  fontSize: 25,
  lineHeight: 33,
  letterSpacing: -0.25,
  fontWeight: 'normal' as const,
  color: green,
};

const bodyTextStyle = {
  ...helvetica,
  fontSize: 18,
  lineHeight: 24.8,
  letterSpacing: -0.18,
  fontWeight: '300' as const,
};

const labelStyle = {
  ...helvetica,
  fontSize: 14,
  fontWeight: 'bold' as const,
  lineHeight: 18.9,
  letterSpacing: 0.84,
};

const linkStyle = {
  ...helvetica,
  fontWeight: '500' as const,
  fontSize: 13,
  letterSpacing: 0.72,
  lineHeight: 16.2,
};

const asterisksTextStyle = {
  fontSize: 16,
  color: green,
  lineHeight: 21.3,
  letterSpacing: 0.95,
  marginBottom: 42,
  fontWeight: 'bold' as const,
  fontFamily: 'Helvetica',
};

export function BaseText(props: TextProps<unknown>) {
  return (
    <Text
      {...fontScalingProps}
      {...props}
      style={[baseTextStyle, props.style]}
    />
  );
}

export function LoraText(props: TextProps<unknown>) {
  return (
    <Text
      {...fontScalingProps}
      {...props}
      style={[loraTextStyle, props.style]}
    />
  );
}

export function H1(props: TextProps<unknown>) {
  return (
    <Text {...fontScalingProps} {...props} style={[h1Style, props.style]} />
  );
}

export function H2(props: TextProps<unknown>) {
  return (
    <Text
      {...fontScalingProps}
      {...props}
      style={[h2Style, props.style]}
    ></Text>
  );
}

export function H3(props: TextProps<unknown>) {
  return (
    <Text {...fontScalingProps} {...props} style={[h3Style, props.style]} />
  );
}

export function H4(props: TextProps<unknown>) {
  return (
    <Text {...fontScalingProps} {...props} style={[h4Style, props.style]} />
  );
}

export function BodyText(props: TextProps<unknown>) {
  return (
    <Text
      {...fontScalingProps}
      {...props}
      style={[bodyTextStyle, props.style]}
    />
  );
}

export function FixedBodyText(props: TextProps<unknown>) {
  return (
    <Text
      {...props}
      allowFontScaling={false}
      style={[bodyTextStyle, props.style]}
    />
  );
}

export function Label(props: TextProps<unknown>) {
  return (
    <Text {...fontScalingProps} {...props} style={[labelStyle, props.style]}>
      {props.children}
    </Text>
  );
}

export function Link(props: TextProps<unknown>) {
  return (
    <Text {...fontScalingProps} {...props} style={[linkStyle, props.style]} />
  );
}

export function AsterisksText(props: TextProps<unknown>) {
  return (
    <Text
      {...fontScalingProps}
      {...props}
      style={[asterisksTextStyle, props.style]}
    />
  );
}
